// src/hooks/useBookings.js
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import drEasyApi from "../Api/Customapi";
import dayjs from "dayjs";
import getErrorMessage from "./getErrorMssg";
import { message } from "antd";

const statusEnum = {
  Pending: 0,
  Cancelled: 1,
  Completed: 2,
  Skipped:3,
  Active:4
};

export const useBookings = (pagination, filters) => {
  const queryClient = useQueryClient();

  // Fetch bookings query
  const bookingsQuery = useQuery({
    queryKey: ["bookings", pagination.current, pagination.pageSize, filters],
    queryFn: async () => {
      const params = {
        PageNumber: pagination.current,
        PageSize: pagination.pageSize,
        ...filters,
      };

      if (filters.fromDate) {
        params.FromDate = dayjs(filters.fromDate).format("YYYY-MM-DD");
      }
      if (filters.toDate) {
        params.ToDate = dayjs(filters.toDate).format("YYYY-MM-DD");
      }

      const response = await drEasyApi.get("/api/Book/getMyBooks?", { params });
      return {
        bookings: response.data.bookings,
        totalCount: response.data.metadata.totalCount,
      };
    },
    staleTime: 1000 * 60 * 1, // 1 minute
    keepPreviousData: true,
    refetchOnWindowFocus: false,
    refetchInterval: 1000 * 60, 
    refetchIntervalInBackground: true,
  });

  // Update booking status mutation
  const updateStatusMutation = useMutation({
    mutationFn: async ({ bookingId, newStatus, reason = "" ,serviceIds}) => {
      await drEasyApi.put("/api/Book/updateStatus", {
        id: bookingId,
        newStatus: statusEnum[newStatus],
        reason,
        serviceIds:serviceIds
      });
    },
    onSuccess: (_, variables) => {
      message.success(`Booking status updated to ${variables.newStatus}`);
      queryClient.invalidateQueries(["bookings"]);
    },
    onError: (error) => {
      message.error(
        "Failed to update booking status: " + getErrorMessage(error)
      );
    },
  });

  return {
    bookingsQuery,
    updateStatusMutation,
  };
};
export const useRecentBookings = (pageSize = 5) => {
  return useQuery({
    queryKey: ["recent-bookings", pageSize],
    queryFn: async () => {
      const response = await drEasyApi.get(
        `/api/Book/getMyBooks?PageNumber=1&PageSize=${pageSize}`
      );
      return response.data.bookings;
    },
    staleTime: 1000 * 60 * 1, // 2 minutes
    refetchOnWindowFocus: true,
  });
};
